export default __webpack_public_path__ + "static/media/Talent_WalkItOff.9ac529ae.png";